export default "__VITE_ASSET__BqHi_T2N__"